














































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import HelpMessage from '../../../../HelpMessage/HelpMessage.vue'
import Icon from '../../../../Icon/Icon.vue'
import Tags from '../../../../Tags/Tags.vue'
import { Item, SelectFn } from '../logic/types'

@Component({
  components: {
    HelpMessage,
    Tags,
    Icon,
  },
})
export default class ListItemView extends Vue {
  @Prop() entity!: Item

  @Prop() selectFn!: SelectFn

  get limitedTag() {
    return typeof this.entity.limited === 'function' ? this.entity.limited() : this.entity.limited
  }

  get tags() {
    const tags = typeof this.entity.tags === 'function' ? this.entity.tags() : this.entity.tags

    return [
      ...tags || [],
      ...this.limitedTag || []
    ]
  }
}
